import React from "react";
import { useFormContext } from "react-hook-form";
import { useDatabase } from "@nozbe/watermelondb/hooks";
import Category from "../../../../utilities/data/model/Category";
import {
  Button,
  FlatActionList,
  FlatActionListItem,
  Page,
} from "@towersystems/roam-common-native";
import {
  CreateProductRootParamList,
  EditProductRootParamList,
} from "../../../../types";
import { StackScreenProps } from "@react-navigation/stack";
import colors from "react-native-ui-lib/src/style/colors";
import { Feather } from "@expo/vector-icons";
import { Q } from "@nozbe/watermelondb";
import { ProductFormValues } from "../../components/ProductForm/types";

export type ProductSelectCategoryScreenProps = StackScreenProps<
  CreateProductRootParamList & EditProductRootParamList,
  "ProductSelectCategoryScreen"
>;

export const ProductSelectCategoryScreen = ({
  navigation,
}: ProductSelectCategoryScreenProps) => {
  const database = useDatabase();

  const [categories, setCategories] = React.useState<Category[] | undefined>();

  const { watch, setValue } = useFormContext<ProductFormValues>();

  const watchedCategoryId = watch("categoryId");
  const watchedDepartmentId = watch("departmentId");

  React.useEffect(() => {
    if (!watchedDepartmentId) {
      return;
    }
    database
      .get<Category>("categories")
      .query(Q.where("department_id", Q.eq(watchedDepartmentId)))
      .fetch()
      .then((l) => setCategories(l));
  }, []);

  React.useEffect(() => {
    navigation.setOptions({
      headerRight: () =>
        !watchedCategoryId ? null : (
          <Button
            label="Remove Category"
            isAction
            onPress={() => {
              setValue("categoryId", "", {
                shouldValidate: true,
                shouldDirty: true,
              });
              navigation.goBack();
            }}
            size="compact"
          ></Button>
        ),
    });
  }, [setValue, watchedCategoryId]);

  const handleOnSelect = React.useCallback((categoryId: string) => {
    setValue("categoryId", categoryId, {
      shouldValidate: true,
      shouldDirty: true,
    });
    navigation.goBack();
  }, []);

  const items: FlatActionListItem[] = React.useMemo(() => {
    return (
      categories?.map((category) => {
        return {
          key: category.id,
          title: category.name,
          onPress: () => handleOnSelect(category.id),
          disabled: watchedCategoryId == category.id,
          componentRight: (icon) => {
            return watchedCategoryId == category.id ? (
              <Feather name="check" size={24} color={colors.primary} />
            ) : (
              icon
            );
          },
        };
      }) || []
    );
  }, [categories, watchedCategoryId, handleOnSelect]);

  return (
    <Page title="Select Category">
      <FlatActionList items={items} />
    </Page>
  );
};
